import React, { useState, useEffect } from 'react';
import './activate_pro.scss';
import { nxtdash_fetch_api, appendFormData } from '../../apicall';
import { useNavigate } from 'react-router-dom';
var plugin_url = nxtext_ajax_object.nxtex_url;
import { __ } from '@wordpress/i18n';

const keyResponse = nxtext_ajax_object.dashData?.keyActmsg || nxtext_ajax_object?.dashData?.tpgb_keyActmsg || {};
const ext_install = nxtext_ajax_object.dashData.extensioninstall
const extensionPro = nxtext_ajax_object.dashData.extensionPro
const Activate_PRO = () => {
    const [activationKey, setActivationKey] = useState(nxtext_ajax_object.dashData?.nxtactivateKey?.nexter_activate_key || nxtext_ajax_object.dashData?.nxtactivateKey?.tpgb_activate_key || '');
    const [activateRes, setactivateRes] = useState({ success: '', message: '' });

    const handleInputChange = (event) => {
        setActivationKey(event.target.value);
    };

    const Navigate = useNavigate();

    useEffect(() => {
        if ( (nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object.dashData.whiteLabel?.nxt_licence_tab == 'on') {
            Navigate('/');
        }
    }, [nxtext_ajax_object.dashData.whiteLabel?.nxt_licence_tab]);

    const handlekeyAct = async (e) => {
        e.preventDefault();

        if(!activationKey){
            return;
        }
        let form = new FormData();
        const formData = { 'action': ext_install &&  extensionPro ? 'nexter_license_activate' : 'tpgb_license_activate', 'submit-key': 'Activate', 'nexter_activate_key': activationKey, 'nexter_activte_nonce': nxtext_ajax_object.ajax_nonce };
        appendFormData(form, formData);
        e.target.innerHTML = '<span class="nxtext-loading-circle nxt-white-loader"></span>';
        try {
            const response = await nxtdash_fetch_api(form);
            const data = await response;

            if (data.success) {
                window.location.reload();
            }else{
                window.location.reload();
            }

        } catch (error) {
            console.error('Error in Response:', error);
        }
    };

    const formatKey = (key) => {
        if (keyResponse.status === "valid" && key.length > 4) {
            return '*'.repeat(key.length - 4) + key.slice(-4);
        }
        return key;
    };

    const handleDeactivate = async (e) => {
        e.preventDefault();

        let form = new FormData();
        const formData = { 'action': ext_install && extensionPro ? 'nexter_license_deactivate' : 'tpgb_license_deactivate', 'submit-key': 'Deactivate', 'nexter_deactivte_nonce': nxtext_ajax_object.ajax_nonce };
        appendFormData(form, formData);
        e.target.innerHTML = '<span class="nxtext-loading-circle nxt-white-loader"></span>';
        try {
            const response = await nxtdash_fetch_api(form);
            const data = await response;

            if (data.success) {
                setactivateRes({ success: '', message: '' });
                setActivationKey('');
                window.location.reload();
            }

        } catch (error) {
            console.error('Error in Response:', error);
        }
    };

    return (
        <div className='nxtext_activate_pro_inner_main'>
            <div className='nxtext_activate_pro_inner_main'>
                <div className='nxtext_section_heading_cover'>
                    <h3 className='nxtext_primary_heading'>{__('Activate PRO', 'nexter-extension')}</h3>
                </div>
            </div>

            <div className='nxt_activate_pro_box_cover_main'>
                <h3 className="nxtext_secondary_heading">{__('Enter your Activation Key', 'nexter-extension')}</h3>
                <div className='nxt_activation_key_box'>
                    <input className='nxtext_text_field' placeholder='Enter your key' type='text' disabled={keyResponse.status === "valid"} value={formatKey(activationKey)} onChange={handleInputChange} />
                    {keyResponse.status === "valid" && keyResponse?.currentsite == true &&
                        <button className="nxtext_blue_common_btn key-deactive" onClick={handleDeactivate}>{__('Deactivate', 'nexter-extension')}</button>
                    }
                    {keyResponse.status === "valid" && keyResponse?.currentsite == false &&
                        <a href={keyResponse?.mainurl || '#'} className="nxtext_blue_common_btn key-manage">{__('Manage', 'nexter-extension')}</a>
                    }
                    {keyResponse.status !== "valid" &&
                        <button disabled={(!activationKey) ? true : false} onClick={handlekeyAct} className="nxtext_blue_common_btn key-activate">{__('Activate', 'nexter-extension')}</button>
                    }
                </div>

                {activateRes.success === true &&
                    <div className='nxt_activated_msg'>
                        <img className='nxt_green_check' src={plugin_url + 'assets/svg/upgrade_table/nxt_green_check.svg'} />
                        {__('Congratulation! License Successfully Activated.', 'nexter-extension')}
                    </div>
                }
                {activateRes.success === false &&
                    <div className='nxt_activated_error_msg'>
                        <img className='nxt_green_check' src={plugin_url + 'assets/svg/error.svg'} />
                        {activateRes.message}
                    </div>
                }
                {keyResponse.status === "valid" &&
                    <div className='nxt_activated_msg' dangerouslySetInnerHTML={{ __html: keyResponse.message }} />
                }
                {keyResponse.status !== "valid" &&
                    <div className='nxt_activated_error_msg dircol' dangerouslySetInnerHTML={{ __html: keyResponse.message }} />
                }
                {keyResponse.status !== "valid" &&
                    <>
                        <h3 className="nxtext_secondary_heading">{__('How to Find the Activation Key?', 'nexter-extension')}</h3>
                        <div className='nxt_activation_steps_cover'>
                            <div className='nxt_activation_step_strip'>
                                <div className='nxt_step_number'>{__('1', 'nexter-extension')}</div>
                                <p className='nxt_step_name'>
                                    <a target="_blank" rel="noopener noreferrer" className='nxt_para_link' href='https://store.posimyth.com/dashboard/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings'>
                                        {__('Visit POSIMYTH Store Dashboard', 'nexter-extension')}
                                    </a>
                                </p>
                            </div>
                            <div className='nxt_activation_step_strip'>
                                <div className='nxt_step_number'>{__('2', 'nexter-extension')}</div>
                                <p className='nxt_step_name'>{__('Copy the License Key', 'nexter-extension')}</p>
                            </div>
                            <div className='nxt_activation_step_strip'>
                                <div className='nxt_step_number'>{__('3', 'nexter-extension')}</div>
                                <p className='nxt_step_name'>{__('Paste the Key here & Hit Activate', 'nexter-extension')}</p>
                            </div>
                        </div>
                        <p className='nxt_btm_txt'>
                            {__('Facing Issues?', 'nexter-extension')} <a target="_blank" rel="noopener noreferrer" className='nxt_para_link' href='https://nexterwp.com/docs/how-to-install-and-activate-nexter-extension/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings'>
                                {__('Check our troubleshooting guide', 'nexter-extension')}
                            </a>
                        </p>
                    </>
                }
            </div>
        </div>
    )
}

export default Activate_PRO;
